import { Component, Input } from '@angular/core';
import { SourceService, Source } from './source.service';

@Component({

    selector: 'syn-source',
    templateUrl: 'source.component.html',
    styleUrls: ['source.component.scss']
})
export class SourceComponent {

    source: Source;
    private _value: string;

    constructor(private sourceService: SourceService) { }

    get sourceValue(): string {
        return this._value;
    }

    // eslint-disable-next-line @angular-eslint/no-input-rename
    @Input('source')
    set sourceValue(value: string) {
        this._value = value;
        this.source = this.sourceService.source(value);
    }

}
